import { effect, inject, Injectable, signal } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ToastCloseEvent } from 'primeng/toast';
import { Observable, Subscriber } from 'rxjs';

interface Options {
  icon?: string, sticky?: boolean, closable?: boolean, life?: number, styleClass?: string,
}

@Injectable({
  providedIn: 'root'
})
export class LayoutToastService {
  private messageService = inject(MessageService);

  protected key = 'layout-toast';
  protected life: number = 2000;

  protected observer: Subscriber<ToastCloseEvent> | undefined;

  protected options: Options = {
    closable: true,
  }

  onClose = signal<ToastCloseEvent | null>(null);

  constructor() {
    effect(() => {
      const event = this.onClose();
      if (event && this.observer) this.observer.next(event);
    });
  }

  showInfo(textOrTpl: string, summary: string = $localize`Info`, options: Options = this.options) {
    this.messageService.add({key: this.key, severity: 'info', summary, detail: textOrTpl, ...options});
  }

  showInfo$(textOrTpl: string, summary: string = $localize`Info`, options: Options = this.options) {
    this.showInfo(summary, textOrTpl, options);
    return new Observable((observer: Subscriber<ToastCloseEvent>) => this.observer = observer);
  }

  showSuccess(textOrTpl: string, summary: string = $localize`Successo`, options: Options = this.options) {
    this.messageService.add({key: this.key, severity: 'success', summary, detail: textOrTpl, ...options});
  }

  showSuccess$(textOrTpl: string, summary: string = $localize`Successo`, options: Options = this.options) {
    this.showSuccess(summary, textOrTpl, options);
    return new Observable((observer: Subscriber<ToastCloseEvent>) => this.observer = observer);
  }

  showWarning(textOrTpl: string, summary: string = $localize`Attenzione`, options: Options = this.options) {
    this.messageService.add({key: this.key, severity: 'warn', summary, detail: textOrTpl, ...options});
  }

  showWarning$(textOrTpl: string, summary: string = $localize`Attenzione`, options: Options = this.options) {
    this.showWarning(summary, textOrTpl, options);
    return new Observable((observer: Subscriber<ToastCloseEvent>) => this.observer = observer);
  }

  showError(textOrTpl: string, summary: string = $localize`Errore`, options: Options = this.options) {
    this.messageService.add({key: this.key, severity: 'error', summary, detail: textOrTpl, ...options});
  }

  showError$(textOrTpl: string, summary: string = $localize`Errore`, options: Options = this.options) {
    this.showError(summary, textOrTpl, options);
    return new Observable((observer: Subscriber<ToastCloseEvent>) => this.observer = observer);
  }

}
